export const showDenominations = (
  amount: number,
  showSymbol?: boolean
): string => {
  return new Intl.NumberFormat("en-IN", {
    style: showSymbol ? "currency" : "decimal",
    currency: "INR",
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  }).format(amount);
};

export const getCurrentAndCompareValue = (data: any) => {
  if (!Array.isArray(data?.details)) {
    return { current: undefined, compare: [] };
  }

  const current = data.details.find((item: any) => item.period === "current");
  const compare = data.details.filter((item: any) => item.period !== "current");

  return { current, compare };
};
